import React, { useState } from "react";
import style from "./section.module.scss";
import LoadingWrapper from "../../../components/LoadingWrapper";
import useRequest from "../../../utils/useRequest";
import moment from "moment";
import {
    getCoursePlanData,
    number2Hanzi,
    toNumber
} from "../../../service/service";
import { Button, DatePicker, Icon, Select } from "antd";
import { DataList } from "./components/DataList";
import Layout from "../components/Layout";
import { useHistory } from "react-router-dom";

interface PageDashBoardSectionProps {
    match: { params: { date: string; section: string } };
}

export default function PageDashBoardSection({
    match: { params }
}: PageDashBoardSectionProps) {
    const { date: urlDate, section } = params;
    const [selectDate, setSelectDate] = useState(moment(urlDate));
    const [selectSection, setSelectSection] = useState(toNumber(section));
    const [data, { loading }] = useRequest(
        () =>
            getCoursePlanData(
                selectDate.format("YYYY-MM-DD"),
                toNumber(selectSection),
                2
            ),
        {},
        [selectSection, selectDate]
    );
    const sections = [1, 3, 5, 7, 9, 11, 13];

    const history = useHistory();

    function goBack() {
        history.push("/dashboard/daily");
    }

    return (
        <Layout>
            <LoadingWrapper loading={loading} isEmpty={!data}>
                {() => (
                    <div className={style.root}>
                        <div className={style.header}>
                            <h1 className={style.title}>
                                <Button className={style.back} onClick={goBack}>
                                    <Icon type="left" />
                                </Button>{" "}
                                课程计划安排
                            </h1>

                            <div className={style.extra}>
                                <DatePicker
                                    defaultValue={selectDate}
                                    onChange={value =>
                                        setSelectDate(value || moment())
                                    }
                                />

                                <Select
                                    defaultValue={selectSection}
                                    style={{ width: 180, marginLeft: 20 }}
                                    onChange={setSelectSection}>
                                    {sections.map(item => (
                                        <Select.Option key={item} value={item}>
                                            第{number2Hanzi(item)} ~{" "}
                                            {number2Hanzi(item + 1)}节
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </div>

                        <DataList
                            data={data!}
                            title={`第${number2Hanzi(
                                selectSection
                            )}节 ~ 第${number2Hanzi(selectSection + 1)}节`}
                        />
                    </div>
                )}
            </LoadingWrapper>
        </Layout>
    );
}
